<template>
  <div class="home-head">
    <van-nav-bar>
      <template #left>
        <img
          :src="safeWapConfig.logo"
          class="home-head-logo"
          @click="toMember"
        />
      </template>
      <template #right>
        <van-popover
          v-if="actions.length > 0"
          v-model="showPopover"
          :theme="islight ? 'light' : 'dark'"
          trigger="click"
          placement="bottom-end"
        >
          <ul>
            <li
              @click="changeLang(item)"
              v-for="(item, index) in actions"
              :key="index"
              class="lang-item-box"
            >
              <div style="float: left; height: 30px; line-height: 30px">
                {{ item.language_name }}
              </div>
              <div style="float: right; height: 30px; line-height: 30px">
                <img
                  :src="require('@/assets/lang/' + item.file_name + '.png')"
                  style="width: 17px; height: 13px"
                />
              </div>
            </li>
          </ul>
          <template #reference>
            <li class="lang-item" v-if="(langval && langval.length > 0)">
              <div class="lang-item-name">{{ getlangName(langval) }}</div>
              <div class="lang-item-icon">
                <img
                  v-if="langval && langval != 'zh-CN'"
                  :src="require('@/assets/lang/' + langval + '.png')"
                  style="width: 17px; height: 13px"
                />
              </div>
            </li>
            <li class="lang-item" v-else>
              <div class="lang-item-icon">
                <svg-icon icon-class="lang" style="font-size: 24px;" />
              </div>
            </li>
          </template>
        </van-popover>
      </template>
    </van-nav-bar>
  </div>
</template>

<script>
import { TokenLangKey, setTokenbyName, getTokenbyName } from "@/utils/cookies";
export default {
  name: "HomeHeader",
  inject: ["app"],
  computed: {
    safeWapConfig() {
      return this.app.wapConfig || {};
    },
  },
  data() {
    return {
      islight: true,
      showPopover: false,
      actions: [
        /*
        { language_name: "English", file_name: "en" }, //英语
        { language_name: "Indonesia", file_name: "id" }, //"印度尼西亚语"
        { language_name: "Creole", file_name: "cr" }, //海地克里奥尔
        { language_name: "Svenska", file_name: "sv" }, //瑞典
        { language_name: "România", file_name: "rm" }, //罗马尼亚
        { language_name: "简体中文", file_name: "zh-cn" }, //中文
        { language_name: "繁體中文", file_name: "zh-TW" }, //繁体
        { language_name: "اردو", file_name: "ur" }, //"乌尔都语"
        { language_name: "বাংলা", file_name: "bn" }, //"孟加拉文"
        { language_name: "हिंदी", file_name: "hi" }, //"印地"
        { language_name: "Latinus", file_name: "la" }, //"拉丁语"
        { language_name: "ภาษาไทย", file_name: "th" }, //泰国
        { language_name: "Melayu", file_name: "ms" }, //马来
        { language_name: "Ελληνικά", file_name: "el" }, //希腊
        { language_name: "فارسی", file_name: "fa" }, //波斯语
        { language_name: "Español", file_name: "es" }, //西班牙语
        { language_name: "Türkçe", file_name: "tr" }, //土耳其
        { language_name: "Português", file_name: "pt" }, //葡萄牙语
        { language_name: "Tiếng Việt", file_name: "vi" }, //越南
        { language_name: "Русский", file_name: "ru" }, //俄罗斯 null
        { language_name: "Deutsch", file_name: "de" }, //德语
        { language_name: "한국인", file_name: "ko" }, //韩国
        { language_name: "日本語", file_name: "ja" }, //日本语
        { language_name: "Italiano", file_name: "it" }, //意大利语
        { language_name: "Français", file_name: "fr" }, //法语
        { language_name: "عربي", file_name: "ar" }, //阿拉伯
         */
      ],
      langval: null,
      isdefault: null,
    };
  },
  mounted() {
    this.langval = getTokenbyName(TokenLangKey);
    this.getLangList();
  },
  methods: {
    toMember() {
      this.$emit("child-event");
    },
    getlangName(val) {
      let reuslt = val;
      this.actions.forEach((item) => {
        if (val == item.file_name) {
          reuslt = item.language_name;
        }
      });
      return reuslt;
    },
    async changeLang(item) {
      this.showPopover = false;
      setTokenbyName(TokenLangKey, item.file_name);
      await this.$http({
        method: "get",
        url: "setLang",
        data: { lang: item.file_name },
      }).then(() => {});
      location.reload();
    },
    async getLangList() {
      await this.$http({
        method: "get",
        url: "getLangList",
      }).then((res) => {
        this.actions = res.data.list;
        this.langval = getTokenbyName(TokenLangKey);
        if (!(this.langval && this.langval.length > 0)) {
          this.actions.forEach((element) => {
            if (element.is_default == 1) {
              this.langval = element.file_name
              setTokenbyName(TokenLangKey,this.langval);
              location.reload();
            }
          });
        }
      });
    },
  },
};
</script>

<style>
</style>
